import Joi from 'joi';

/**
 * Schema for existing record validation.
 */
export const updateVehicleColorSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
